import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { DrugCompanyDetailComponent } from './drug-company-detail/drug-company-detail.component';
import { MatPaginator } from '@angular/material/paginator';
import { PaginationResult } from 'src/app/models/common.response';
import { debounceTime, distinctUntilChanged, finalize, Observable, Subject, switchMap, takeUntil } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { DrugCompanyService } from './drug-company.service';
import { IDrugCompany } from './idrug-company';
import { PAGE_SIZE_OPTIONS } from 'src/app/common/constant/constants.type';


@Component({
  selector: 'app-drug-company-list',
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './drug-company-list.component.html',
  styleUrl: './drug-company-list.component.scss'
})
export class DrugCompanyListComponent implements OnInit {


  displayedColumns: string[] = [
    'DrugCompanyName',
    'action',
  ];
  dataSource = new MatTableDataSource<IDrugCompany>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
    Object.create(null);

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  pagination: PaginationResult;
  drugCompanycount: number = 0;
  drugCompanies$: Observable<IDrugCompany[]>;
  drugCompanydata: IDrugCompany[];
  isLoading: boolean = false;
  searchdrugCompany: FormControl = new FormControl();
  pageSizeOptions = PAGE_SIZE_OPTIONS;

  constructor(
    private _drugCompanyService: DrugCompanyService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this._drugCompanyService.pagination$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((pagination: PaginationResult | null) => {
        if (pagination) {
          this.pagination = pagination;
          this.drugCompanycount = this.pagination.rowCount;

        }
      });

    this._drugCompanyService.drugcompanies$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data) => {
        this.drugCompanydata = data;
        this.dataSource = new MatTableDataSource(this.drugCompanydata); // Correct initialization
        this.dataSource.paginator = this.paginator;
      });

    this.searchdrugCompany.valueChanges.pipe(
      takeUntil(this._unsubscribeAll),
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((query) => {
        return this._drugCompanyService.getAllDrugComapany({
          pageNumber: 0,
          pageSize: this.pagination.pageSize,
          isDescending: false,
          searchValue: query || ''
        }).pipe(
          finalize(() => (this.isLoading = false))
        );
      })
    ).subscribe((response) => {
      if (response && response.result) {
        this.dataSource.data = response.result.drugCompanyDetails;
        this.drugCompanycount = response.result.pagination.rowCount;
      }
    });
  }

  onAddDrugComapany() {
    this.dialog.open(DrugCompanyDetailComponent, {
      width: '700px',
      height: 'auto',
      disableClose: true,
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.refreshDrugCompany();
      }
    });
  }

  onUpdateDrugCompany(DrugCompanyDetails: IDrugCompany) {
    this.dialog.open(DrugCompanyDetailComponent, {
      width: '600px',
      height: 'auto',
      disableClose: true,
      data:
      {
        drugcompany: DrugCompanyDetails,
        isEdit: true
      }
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.refreshDrugCompany();
      }
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  refreshDrugCompany() {
    const globalSearchValue = this.searchdrugCompany?.value?.trim();
    const requestPayload: any = {
      pageNumber: 0,
      pageSize: this.pagination?.pageSize || 100,
      isDescending: false
    };

    if (globalSearchValue) {
      requestPayload.SearchValue = globalSearchValue;
    } else {
      requestPayload.pageNumber = this.pagination?.currentPage || 0;
    }

    this._drugCompanyService.getAllDrugComapany(requestPayload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response) => {
        if (response && response.result) {
          const DrugCompany = response.result.drugCompanyDetails;
          this.drugCompanydata = DrugCompany;
          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(DrugCompany);
          } else {
            this.dataSource.data = DrugCompany;
          }
          this.dataSource.paginator = this.paginator;
          this.drugCompanycount = response.result.pagination.rowCount;
          this.pagination = response.result.pagination;
        }
      });

  }

}
